var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailOpenFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4998 12V6.34225C13.4998 5.96273 13.0936 5.72157 12.7604 5.9033L8.47836 8.23883C8.17988 8.40162 7.81914 8.40162 7.52067 8.23881L3.23894 5.90332C2.90575 5.72158 2.49951 5.96274 2.49951 6.34227V12C2.49951 12.5523 2.94723 13 3.49951 13H12.4998C13.0521 13 13.4998 12.5523 13.4998 12Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6L8 3L13 6",
    stroke: "#002A69",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailOpenFill);
export default __webpack_public_path__ + "static/media/Mail_open_fill.9199d4ca9de8376a6af5012c23327435.svg";
export { ForwardRef as ReactComponent };